module.exports = __webpack_public_path__ + "img/flight.5abb424e.svg";